import { render, staticRenderFns } from "./ListProcessEvaluationsProcess.vue?vue&type=template&id=6facece0"
import script from "./ListProcessEvaluationsProcess.vue?vue&type=script&lang=js"
export * from "./ListProcessEvaluationsProcess.vue?vue&type=script&lang=js"
import style0 from "./ListProcessEvaluationsProcess.vue?vue&type=style&index=0&id=6facece0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports